<div class="portfolio-card" [ngClass]="{ reversed: reversed }">
  <div class="content-wrapper">
    <img [src]="imageUrl" alt="{{ title }}" class="project-image" />

    <div class="project-text">
      <h3 class="title">{{ title }}</h3>
      <p class="stack">{{ techStack }}</p>
      <p class="desc">{{ description }}</p>
      <div class="buttons">
        <a [href]="liveUrl" target="_blank">Live Test</a>
        <a [href]="githubUrl" target="_blank">Github</a>
      </div>
    </div>
  </div>
</div>
